<template>
  <hm-content title="">
    <div class="tmplmsg_detail_box mod_default_box" id="js_detail_container">
      <div class="flex">
        <div class="tmplmsg_detail_preview">
          <div class="wx_mobile_panel tmplmsg_card">
            <div class="wx_mobile_panel_hd tmplmsg_card_hd">
              <div class="wx_mobile_cell">
                <div class="wx_mobile_cell_hd">
                  <span class="tmplmsg_owner_avatar radius_avatar"
                    ><img
                      src="https://wx.qlogo.cn/mmhead/Q3auHgzwzM6TeXJFbXibcBPwyvZ2PmpFUvibXbNicbiaicKmwjtmAcrk52w/0"
                      alt=""
                  /></span>
                </div>
                <div
                  class="wx_mobile_cell_bd tmplmsg_owner_nickname"
                  title=""
                ></div>
              </div>
            </div>
            <div class="wx_mobile_panel_bd">
              <span v-html="details.example"></span>
              <!-- <div class="tmplmsg_preview_title">订单支付成功通知</div>
              <div class="tmplmsg_preview_desc">2019年10月</div>
              <ul class="tmplmsg_preview_meta_list simple_preview_box">
                <li
                  class="tmplmsg_preview_meta_item simple_preview_item flex item-center"
                >
                  <label for="" class="simple_preview_label">物品名称</label>
                  <p class="simple_preview_value">梨子</p>
                </li>

                <li
                  class="tmplmsg_preview_meta_item simple_preview_item flex item-center"
                >
                  <label for="" class="simple_preview_label">订单号码</label>
                  <p class="simple_preview_value">123456789</p>
                </li>
              </ul> -->
            </div>
            <div class="wx_mobile_panel_ft">
              <a
                class="wx_mobile_cell wx_mobile_cell_access wx_mobile_cell_link"
                href="javascript:;"
              >
                <div class="wx_mobile_cell_ft"></div>
                <div class="wx_mobile_cell_bd">查看详情</div>
              </a>
            </div>
          </div>
          <p class="tips_global text-center mt20">内容示例</p>
        </div>
        <div class="tmplmsg_detail_info flex-1">
          <ul class="tmplmsg_detail_meta_list">
            <li class="tmplmsg_detail_meta_item">
              <label for="" class="tmplmsg_detail_meta_title">模板ID</label>
              <div class="tmplmsg_detail_meta_value">
                {{ details.templateId || details.templateIdShort }}
              </div>
            </li>
            <li class="tmplmsg_detail_meta_item  flex item-center">
              <label for="" class="tmplmsg_detail_meta_title">标题</label>
              <div class="tmplmsg_detail_meta_value">{{ details.title }}</div>
            </li>
            <li class="tmplmsg_detail_meta_item  flex">
              <label for="" class="tmplmsg_detail_meta_title">关键词</label>
              <div class="tmplmsg_detail_meta_value">
                <ul class="simple_preview_box">
                  <li class="simple_preview_item flex item-center">
                    <span v-html="details.content"></span>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="flex flex-center">
      <el-button
        @click="save"
        size="small"
        type="primary"
        v-if="type === 'edit'"
        >保存</el-button
      >
      <el-button size="small" @click="backPrev">返回</el-button>
    </div>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      details: {},
      type: ""
    };
  },
  computed: {},
  watch: {},
  created() {
    const detailsJson = this.$route.query.details;
    this.type = this.$route.query.type;
    if (detailsJson) {
      this.details = JSON.parse(detailsJson);
      this.details.content = this.details.content.replace(/\\n/g, "<br/>");
      this.details.example = this.details.example
        .replace(/\\n/g, "<br/>")
        .replace(/\\r/g, "<br/>");
    }
  },
  mounted() {},
  methods: {
    async save() {
      await this.$store.dispatch("addOfficialAccountTempMsG", this.details);
      this.$message({
        message: " 操作成功",
        type: "success"
      });
      this.backPrev();
    }
  }
};
</script>
<style lang="scss" scoped>
.tmplmsg_detail_preview {
  width: 320px;
  margin-right: 60px;
  line-height: 24px;
}

.tmplmsg_detail_meta_list {
  line-height: 24px;
}

.tmplmsg_card {
  border: 1px solid #e7e7eb;
  border-radius: 5px;
  background-color: #fff;
  margin-top: 10px;
  overflow: hidden;
  position: relative;
}

.wx_mobile_panel_hd {
  padding: 14px 15px 10px;
  color: #9a9a9a;
  font-size: 13px;
  position: relative;
  border-bottom: 1px solid #e7e7eb;
}

.wx_mobile_cell {
  display: block;
  overflow: hidden;
  *zoom: 1;
  padding: 9px 15px;
  position: relative;
}

.tmplmsg_card .tmplmsg_owner_avatar {
  width: 32px;
  height: 32px;
  padding: 0;
  margin-right: 12px;
  display: block;
  img {
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    -moz-border-radius: 50%;
    -webkit-border-radius: 50%;
    background-color: #eee;
  }
}

.wx_mobile_panel_bd {
  min-height: 230px;
  padding: 15px;
}

.tmplmsg_card .tmplmsg_preview_desc {
  color: #9a9a9a;
  font-size: 12px;
}

.tmplmsg_preview_meta_list {
  padding: 30px 0;
  font-size: 13px;
}

.tmplmsg_card .tmplmsg_preview_meta_list .simple_preview_label {
  color: #9a9a9a;
  margin-right: 1em;
}

.tips_global {
  color: #9a9a9a;
}

.tmplmsg_detail_meta_item:first-child {
  margin-top: 0;
  border-top-width: 0;
}

.tmplmsg_detail_meta_item {
  padding: 1em 0;
}

.tmplmsg_detail_meta_value .simple_preview_label {
  color: #9a9a9a;
  margin-right: 1em;
}

.tmplmsg_detail_meta_title {
  color: #9a9a9a;
  float: left;
  width: 4em;
  margin-right: 1em;
}
</style>
